import CloseIcon from 'components/ReusableComponents/CloseIcon'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useState } from 'react'

import styles from './ImageViewerDialog.module.scss'

const ImageViewerDialog = ({ mediaUrl, onClose, mediaName }) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <Dialog>
      <div className={styles.floatingButtons}>
        <button onClick={onClose} className={styles.closeIcon}>
          <CloseIcon />
        </button>
      </div>
      {isLoading && <LoadingIndicator white />}
      <div className={styles.imageHolder} style={{ opacity: isLoading ? 0 : 1 }}>
        <img
          src={mediaUrl}
          style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
          alt={mediaName}
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </Dialog>
  )
}

export default ImageViewerDialog
